import React from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "@/components/Index/Navbar";
import Footer from "@/components/Index/Footer";
import { ArrowLeft } from "lucide-react";

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    // Jika ada riwayat halaman sebelumnya, kembali ke URL tersebut. Jika tidak, arahkan ke beranda.
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/");
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-[#FFF8F6]">
      <Navbar />
      <main className="flex-grow flex items-center justify-center px-4 py-16 md:py-24">
        <div className="max-w-md w-full text-center bg-white rounded-3xl p-8 md:p-12 shadow-sm border border-red-100">
          {/* Angka 404 Besar */}
          <h1 className="text-6xl md:text-8xl font-extrabold text-[#B70100] tracking-tight mb-4 select-none">
            404
          </h1>

          {/* Judul & Penjelasan Ringkas */}
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">
            Halaman Tidak Ditemukan
          </h2>
          <p className="text-gray-600 mb-8 leading-relaxed text-sm md:text-base">
            Halaman yang Anda cari tidak ditemukan atau telah dipindahkan.
          </p>

          {/* Tombol Aksi Tunggal: Kembali */}
          <div className="flex items-center justify-center">
            <button
              onClick={handleGoBack}
              className="inline-flex items-center justify-center gap-2 bg-[#B70100] hover:bg-[#9a0100] text-white font-medium px-8 py-3 rounded-full transition-colors shadow-sm cursor-pointer"
            >
              <ArrowLeft className="w-4 h-4" />
              Kembali
            </button>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFound;
